import { render, staticRenderFns } from "./TreatmentMatrixList.vue?vue&type=template&id=3f7ceb12&scoped=true"
import script from "./TreatmentMatrixList.vue?vue&type=script&lang=js"
export * from "./TreatmentMatrixList.vue?vue&type=script&lang=js"
import style0 from "./TreatmentMatrixList.vue?vue&type=style&index=0&id=3f7ceb12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7ceb12",
  null
  
)

export default component.exports